var _rect, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenshot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 44,
    y: 44,
    width: 44,
    height: 44,
    rx: 22,
    transform: "rotate(-180 44 44)",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 23,
    r: 3,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7778 31H24.2222C27.3433 31 28.9038 31 30.0248 30.2646C30.51 29.9462 30.9267 29.5371 31.251 29.0607C32 27.9601 32 26.4279 32 23.3636C32 20.2994 32 18.7672 31.251 17.6666C30.9267 17.1901 30.51 16.781 30.0248 16.4627C29.3044 15.9901 28.4027 15.8212 27.022 15.7609C26.3631 15.7609 25.7959 15.2707 25.6667 14.6364C25.4728 13.6849 24.6219 13 23.6337 13H20.3663C19.3781 13 18.5272 13.6849 18.3333 14.6364C18.2041 15.2707 17.6369 15.7609 16.978 15.7609C15.5973 15.8212 14.6956 15.9901 13.9752 16.4627C13.49 16.781 13.0733 17.1901 12.749 17.6666C12 18.7672 12 20.2994 12 23.3636C12 26.4279 12 27.9601 12.749 29.0607C13.0733 29.5371 13.49 29.9462 13.9752 30.2646C15.0962 31 16.6568 31 19.7778 31Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 20H28",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshot);
export default __webpack_public_path__ + "static/media/screenshot.2bc02cc7deb20c6458ccceb09effd7a1.svg";
export { ForwardRef as ReactComponent };